import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";

import fr from "./locales/fr.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "monrepetiteur_lang",
    },
  });

// Keep the global axios Accept-Language header in sync with the active language.
const applyAxiosLang = (lng) => {
  const code = (lng || "fr").split("-")[0];
  axios.defaults.headers.common["Accept-Language"] = code;
  try {
    document.documentElement.setAttribute("lang", code);
  } catch (_) {
    /* noop */
  }
};

applyAxiosLang(i18n.resolvedLanguage || i18n.language || "fr");
i18n.on("languageChanged", applyAxiosLang);

export default i18n;
